import React, { useContext, useState } from 'react';
import { Formik } from 'formik';
import ErrorBox, { noError } from '../../common/components/ErrorBox';
import { BrandForm, validateForm } from '../components/BrandForm';
import { createBrand } from '../api/brands.api';
import { mutate } from 'swr';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../../common/context/userContext';
import { PageFrame } from '../../common/components/PageFrame';

export const AddBrandPage = () => {
  const history = useHistory();
  const [error, setError] = useState(noError);
  const { isAdmin, companyId } = useContext(UserContext);

  const handleSubmit = async (values) => {
    try {
      await createBrand(values);
      await mutate('/portal/brands');
      history.push('/brands/list');
    } catch (e) {
      console.log(e);
      setError({
        title: 'An error occurred saving this brand',
        msg: 'Please try again',
      });
    }
  };

  return (
    <PageFrame title="Add Brand">
      <Formik
        initialValues={{ ...(isAdmin ? {} : { company: { id: companyId } }) }}
        validate={validateForm}
        onSubmit={handleSubmit}
      >
        <BrandForm />
      </Formik>
      <ErrorBox
        title={error.title}
        msg={error.msg}
        onClose={() => setError(noError)}
      />
    </PageFrame>
  );
};
